export const API_BASE: string = import.meta.env?.VITE_API_URL || "http://localhost:5200";
export const WS_BASE: string = import.meta.env?.VITE_WS_URL || "https://localhost:5200";
